export default class NewTract {
    tractName: string;
    grossAcres: number;
    horizonName: string;
    horizonBeginDepth: number;
    horizonEndDepth: number;
    sectionNumber: number;
    mapNumber: number;
    legalDescription: string;
    countyId: number;
    // Form key
    name: string;
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/NewTract.ts